import { render, staticRenderFns } from "./TagGroup.vue?vue&type=template&id=1039296e&scoped=true&"
import script from "./TagGroup.vue?vue&type=script&lang=js&"
export * from "./TagGroup.vue?vue&type=script&lang=js&"
import style0 from "./TagGroup.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TagGroup.vue?vue&type=style&index=1&id=1039296e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1039296e",
  null
  
)

/* custom blocks */
import block0 from "./TagGroup.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports